import React, { useState, useEffect, useRef } from 'react';
import { Printer, Edit, X, Send, Upload } from 'lucide-react';
import apiService from "../../config";
import { useSignature } from '../../DigitalSignature/UseSignatue';
import SignaturePad from '../../DigitalSignature/SignaturePad';

const Namuna_B = ({ setSubComponent }) => {
  const documentRef = useRef(null);

  // Project and Proposal IDs
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [currentProposalId, setCurrentProposalId] = useState(null);

  // Data states
  const [rehabData, setRehabData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Edit states
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingRehab, setEditingRehab] = useState(null);
  const [editForm, setEditForm] = useState({
    owner_name: '',
    remarks: ''
  });

  // Send to DRO states
  const [showSendToDROModal, setShowSendToDROModal] = useState(false);
  const [remarksDRO, setRemarksDRO] = useState('Approved');
  const [selectedUserDRO, setSelectedUserDRO] = useState('');
  const [sendingToDRO, setSendingToDRO] = useState(false);
  const [selectedDocumentDRO, setSelectedDocumentDRO] = useState(null);
  const [usersDRO, setUsersDRO] = useState([]);
  const [loadingUsersDRO, setLoadingUsersDRO] = useState(false);

  // User role
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const userRole = parseInt(userData?.data?.user_role || userData?.user_role, 10);
  const PROJECT_INCHARGE_ROLE = 18;

  const [fullName, setFullName] = useState('');
  const [designation , setDesignation] =useState('');
  const [showSignaturePad, setShowSignaturePad] = useState(false);
    const [pdfForSigning, setPdfForSigning] = useState(null);
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [viewerFile, setViewerFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const {
      uploadStatus,
      uploadError,
      selectedSignDocument,
      resetSignatureState,
      setUploadStatus,
      setUploadError,
      signDocument
    } = useSignature();

  useEffect(() => {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      setFullName(userData.full_name || '');
      setDesignation(userData.designation || '');
    }, []);

  // Get Project and Proposal IDs
  useEffect(() => {
    const getProjectInfo = () => {
      const selectedProject = localStorage.getItem('selectedProject');
      if (selectedProject) {
        try {
          const project = JSON.parse(selectedProject);
          return project.project_id || project.id;
        } catch (e) {
          console.error('Error parsing selectedProject:', e);
        }
      }

      const userData = localStorage.getItem('userData');
      if (userData) {
        try {
          const user = JSON.parse(userData);
          return user.data?.project_id || user.project_id;
        } catch (e) {
          console.error('Error parsing userData:', e);
        }
      }
      return null;
    };

    const getProposalInfo = () => {
      const userData = localStorage.getItem('userData');
      if (userData) {
        try {
          const user = JSON.parse(userData);
          return user?.data?.default_proposal || user?.data?.proposal_id || user?.default_proposal || user?.proposal_id || null;
        } catch (e) {
          console.error('Error parsing userData for proposal:', e);
        }
      }
      return null;
    };

    setCurrentProjectId(getProjectInfo());
    setCurrentProposalId(getProposalInfo());
  }, []);

  useEffect(() => {
    if (currentProjectId && currentProposalId) {
      fetchRehabData();
    }
  }, [currentProjectId, currentProposalId]);

  const fetchRehabData = async () => {
    try {
      setLoading(true);
      const files = await apiService.getRehabA(currentProjectId, currentProposalId);
      setRehabData(files);
    } catch (error) {
      console.error("Rehab API failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchUsersDRO = async () => {
    const role = 22;
    setLoadingUsersDRO(true);
    try {
      const response = await apiService.getAllUserRoleDRO(role, currentProjectId, currentProposalId);
      if (response.status === 200 && response.data) {
        setUsersDRO(Array.isArray(response.data) ? response.data : []);
      } else {
        setUsersDRO([]);
      }
    } catch (error) {
      console.error('Error fetching DRO users:', error);
      setUsersDRO([]);
    } finally {
      setLoadingUsersDRO(false);
    }
  };

  useEffect(() => {
    if (showSendToDROModal) {
      fetchUsersDRO();
    }
  }, [showSendToDROModal]);

  const handleEdit = (item) => {
    setEditingRehab(item);
    setEditForm({
      owner_name: item.owner_name || '',
      namuna_b_remarks: item.namuna_b_remarks || ''
    });
    setShowEditModal(true);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleUpdateRemarks = async () => {
    if (!editingRehab) return;

    try {
      setLoading(true);
      const payload = new FormData();
      payload.append('owner_name', editForm.owner_name);
      payload.append('namuna_b_remarks', editForm.namuna_b_remarks);

      const rehabId = editingRehab.rehab_id || editingRehab.id;
      const response = await apiService.patchUpdateRehabA(rehabId, payload);

      if (response.status === 200) {
        alert('यशस्वीरित्या अद्यतनित केले / Updated successfully!');
        setShowEditModal(false);
        setEditingRehab(null);
        setEditForm({
          owner_name: '',
          namuna_b_remarks: ''
        });
        fetchRehabData();
      }
    } catch (error) {
      console.error('Error updating:', error);
      alert('अद्यतनित करण्यात अयशस्वी / Failed to update');
    } finally {
      setLoading(false);
    }
  };

  const handleSendToDRO = async () => {
    if (!selectedUserDRO || !selectedDocumentDRO) {
      alert('Please select user and upload document');
      return;
    }

    setSendingToDRO(true);

    try {
      const formData = new FormData();
      formData.append('project_id', currentProjectId);
      formData.append('proposal_id', currentProposalId);
      formData.append('namuna_b_remarks', remarksDRO);
      formData.append('usr_id', selectedUserDRO);
      formData.append('document', selectedDocumentDRO);

      const response = await apiService.postTrackingSendToDRO(formData);

      if (response.status === 200) {
        alert('Successfully sent to DRO');
        setShowSendToDROModal(false);
        setSelectedUserDRO('');
        setRemarksDRO('Approved');
        setSelectedDocumentDRO(null);
      } else {
        alert('Failed to send to DRO');
      }
    } catch (error) {
      console.error('Error sending to DRO:', error);
      alert('Failed to send to DRO');
    } finally {
      setSendingToDRO(false);
    }
  };

  const handlePrint = () => {
    const printContent = documentRef.current?.innerHTML;
    if (!printContent) {
      alert("No content available to print.");
      return;
    }

    const printWindow = window.open('about:blank', '_blank');

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Print - नमुना "ब" रजिस्टर</title>
          <meta charset="UTF-8">
          <style>
            @page {
              size: A4 landscape;
              margin-top: 0.3in;
              margin-bottom: 0.3in;
              margin-left: 0.75in;
              margin-right: 0.6in;
            }
            
            @media print {
              .no-print {
                display: none !important;
              }
            }
            
            body {
              font-family: 'Noto Sans Devanagari', 'Mangal', 'Arial', sans-serif;
              font-size: 13px;
              line-height: 1.5;
              color: #000;
              margin: 0;
              padding: 20px;
            }

            .signature{
            text-align : right;
            margin-top : 40px;
            }

            .text-center {
              text-align: center;
            }

            .font-bold {
              font-weight: bold;
            }

            .mb-2 {
              margin-bottom: 4px;
            }

            .mb-3 {
              margin-bottom: 6px;
            }

            .mb-4 {
              margin-bottom: 8px;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              border: 2px solid #000;
            }

            th, td {
              border: 1px solid #000;
              padding: 4px 6px;
              vertical-align: top;
            }

            th {
              font-weight: bold;
              text-align: center;
            }

            @media print {
              body {
                print-color-adjust: exact;
                -webkit-print-color-adjust: exact;
              }
            }
          </style>
        </head>
        <body>
          ${printContent}
        </body>
      </html>
    `);

    printWindow.document.close();

    printWindow.onload = function () {
      printWindow.focus();
      printWindow.print();
    };
  };

  const handleUploadedFile = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  resetSignatureState();     // 🔥 important
  setPdfForSigning(file);
  setShowSignaturePad(true);
};

 useEffect(() => {
  if (!selectedSignDocument) return;

  const postSignedPdf = async () => {
    try {
      const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
      const projectId = selectedProject?.id || selectedProject?.project_id;
      const proposalId = localStorage.getItem("currentProposalId");

      if (!projectId || !proposalId) {
        console.error("Missing projectId or proposalId");
        return;
      }

      await apiService.postAddSignaturePDF(
        projectId,
        proposalId,
        "NamunaB",      // 🔁 change per section
        selectedSignDocument   // ✅ signed PDF only
      );

      const sectionRes = await apiService.getSectionFile(
        projectId,
        proposalId,
        "NamunaB"
      );

      if (sectionRes?.isSignAvailable && sectionRes.data?.[0]?.file_path) {
        setPreviewUrl(sectionRes.data[0].file_path);
      }

    } catch (error) {
      console.error("Error posting signed PDF:", error);
    }
  };

  postSignedPdf();
}, [selectedSignDocument]);

const handleViewSignedPdf = async () => {
  try {
    const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
    const projectId = selectedProject?.id || selectedProject?.project_id;
    const proposalId = localStorage.getItem("currentProposalId");

    if (!projectId || !proposalId) {
      alert("Project or Proposal not found");
      return;
    }

    const res = await apiService.getSectionFile(
      projectId,
      proposalId,
      "NamunaB" // 🔁 change per section
    );

    if (res?.isSignAvailable && res?.data?.[0]?.file_path) {
      setViewerFile(res.data[0].file_path);
      setIsViewerOpen(true);     // modal
      // OR 👉 window.open(res.data[0].file_path, "_blank");
    } else {
      alert("Signed document not available");
    }
  } catch (error) {
    console.error("Error viewing signed PDF:", error);
    alert("Unable to open signed document");
  }
};

const SignatureLoader = ({ text }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
    <div className="bg-white rounded-lg p-6 flex flex-col items-center space-y-4">
      <div className="animate-spin rounded-full h-10 w-10 border-4 border-blue-600 border-t-transparent"></div>
      <p className="text-sm font-medium text-gray-700">{text}</p>
    </div>
  </div>
);

  const groupRehabData = () => {
    const grouped = {};

    rehabData
      // Filter out records that do not have an owner_name
      .filter(item => item.owner_name && item.owner_name.trim() !== '')
      .forEach(item => {
        const key = `${item.district_name}|${item.taluka_name}|${item.village_name}|${item.base_district_name}|${item.base_taluka_name}|${item.base_village_name}`;

        if (!grouped[key]) {
          grouped[key] = {
            district_name: item.district_name,
            taluka_name: item.taluka_name,
            village_name: item.village_name,
            base_district_name: item.base_district_name,
            base_taluka_name: item.base_taluka_name,
            base_village_name: item.base_village_name,
            items: []
          };
        }

        grouped[key].items.push(item);
      });

    return Object.values(grouped);
  };

  return (
    <div className="max-w-5xl mx-auto p-6">
      {/* Action Buttons */}
      <div className="flex justify-start mb-6 gap-4 flex-wrap">
        {/* {userRole === PROJECT_INCHARGE_ROLE && (
          <button
            onClick={() => setShowSendToDROModal(true)}
            className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors shadow-md"
          >
            <Send className="inline mr-2" size={16} />
            Send to DRO
          </button>
        )} */}

        <button className="relative">
                  <label className="flex items-center space-x-2 px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 cursor-pointer">
                    <Upload size={18} />
                    <span>Upload Signature</span>
                    <input
                      type="file"
                      accept="application/pdf,image/*"
                      className="hidden"
                      onChange={handleUploadedFile}
                    />
                  </label>
                </button>
      
                <button
                onClick={handleViewSignedPdf}
                className="flex items-center space-x-2 px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700"
              >
                <Printer size={18} />
                <span>View Signed PDF</span>
              </button>

        <button
          onClick={handlePrint}
          className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors shadow-md"
        >
          <Printer size={20} />
          Print
        </button>
      </div>

      {/* Loading State */}
      {loading && (
        <div className="text-center py-10">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading data...</p>
        </div>
      )}

      {/* Document Preview */}
      {!loading && (
        <div className="bg-white shadow-2xl rounded-lg overflow-hidden">
          <div
            ref={documentRef}
            className="document-container"
            style={{
              fontFamily: "'Noto Sans Devanagari', 'Mangal', Arial, sans-serif",
              padding: "30px",
              fontSize: "15px",
              lineHeight: "1.5"
            }}
          >
            {groupRehabData().map((group, groupIndex) => (
              <div key={groupIndex} className={groupIndex > 0 ? "mt-12 page-break" : ""}>
                {/* Header */}
                <div className="text-center mb-2" style={{ fontSize: '15px' }}>
                  मौजे {group.village_name} टु. तालुका {group.taluka_name} जिल्हा {group.district_name} येथील नवीन पुनर्वसित गावठाण मौजे {group.base_village_name} तालुका {group.base_taluka_name}
                </div>
                <div className="text-center mb-3" style={{ fontSize: '15px' }}>
                  जिल्हा {group.base_district_name} च्या अभिन्यास Lay-Out व दिनांक 10.11.2023 रोजी प्रकल्पप्रस्ताना भूखंड वाटप केलेल्या यादीनुसार तयार करण्यात आलेले
                </div>
                <div className="text-center font-bold mb-4" style={{ fontSize: '15px' }}>
                  नमुना "ब" रजिस्टर
                </div>

                {/* Table */}
                <table className="w-full border-2 border-black">
                  <thead>
                    <tr className="font-bold">
                      <th className="border border-black p-2" style={{ width: '50px' }}>अ.क्र.</th>
                      <th className="border border-black p-2" style={{ width: '60px' }}>भूखंड<br />क्रमांक</th>
                      <th className="border border-black p-2" style={{ width: '120px' }}>भूखंडाचा आकार</th>
                      <th className="border border-black p-2" style={{ width: '80px' }}>क्षेत्रफळ<br />चौ.मी.</th>
                      <th className="border border-black p-2">चतु:सीमा</th>
                      <th className="border border-black p-2" style={{ width: '180px' }}>प्रकल्पप्रस्ताचे नाव</th>
                      <th className="border border-black p-2" style={{ width: '100px' }}>शेरा</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="text-center font-bold">
                      <td className="border border-black p-2">१</td>
                      <td className="border border-black p-2">२</td>
                      <td className="border border-black p-2">३</td>
                      <td className="border border-black p-2">४</td>
                      <td className="border border-black p-2">५</td>
                      <td className="border border-black p-2">६</td>
                      <td className="border border-black p-2">७</td>
                    </tr>
                    {group.items.map((row, index) => {
                      const boundaries = [
                        row.boundary_north ? `उत्तर :- ${row.boundary_north}` : null,
                        row.boundary_south ? `दक्षिण :- ${row.boundary_south}` : null,
                        row.boundary_east ? `पूर्व :- ${row.boundary_east}` : null,
                        row.boundary_west ? `पश्चिम :- ${row.boundary_west}` : null
                      ].filter(Boolean);

                      return (
                        <React.Fragment key={row.rehab_id || row.id || index}>
                          {boundaries.map((boundary, idx) => (
                            <tr key={`${row.rehab_id || row.id}-${idx}`}>
                              {idx === 0 && (
                                <>
                                  <td className="border border-black p-2 text-center" rowSpan={boundaries.length}>
                                    <Edit
                                      size={16}
                                      onClick={() => handleEdit(row)}
                                      className="text-blue-600 hover:text-blue-800 no-print cursor-pointer inline-block"
                                      title="Edit"
                                    />
                                    <span className="ml-2">{index + 1}</span>
                                  </td>
                                  <td className="border border-black p-2 text-center" rowSpan={boundaries.length}>
                                    {row.plot_no}
                                  </td>
                                  <td className="border border-black p-2 text-center" rowSpan={boundaries.length}>
                                    {row.area || row.plot_size || '-'}
                                  </td>
                                  <td className="border border-black p-2 text-center" rowSpan={boundaries.length}>
                                    {row.area_sq_mtr || row.plot_size}
                                  </td>
                                </>
                              )}
                              <td className="border border-black p-2" style={{ fontSize: '15px' }}>
                                {boundary}
                              </td>
                              {idx === 0 && (
                                <>
                                  <td className="border border-black p-2" rowSpan={boundaries.length}>
                                    {row.owner_name || ''}
                                  </td>
                                  <td className="border border-black p-2" rowSpan={boundaries.length}>
                                    {row.namuna_b_remarks || ''}
                                  </td>
                                </>
                              )}
                            </tr>
                          ))}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
                <div className="mt-10 text-right signature">
          <div className="font-bold">{fullName}</div>
          <div>{designation}</div>
        </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {showEditModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md my-8">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold text-gray-800">माहिती संपादित करा</h2>
                <button
                  onClick={() => {
                    setShowEditModal(false);
                    setEditingRehab(null);
                    setEditForm({
                      owner_name: '',
                      namuna_b_remarks: ''
                    });
                  }}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <X size={24} />
                </button>
              </div>

              <div className="space-y-4">
                {/* <div>
                  <label className="block text-sm font-medium mb-2">प्रकल्पप्रस्ताचे नाव</label>
                  <input
                    name="owner_name"
                    value={editForm.owner_name}
                    onChange={handleEditChange}
                    className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                    placeholder="प्रकल्पप्रस्ताचे नाव प्रविष्ट करा"
                  />
                </div> */}

                <div>
                  <label className="block text-sm font-medium mb-2">शेरा (Remarks)</label>
                  <textarea
                    name="namuna_b_remarks"
                    value={editForm.namuna_b_remarks}
                    onChange={handleEditChange}
                    rows={4}
                    className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                    placeholder="शेरा प्रविष्ट करा"
                  />
                </div>
              </div>

              <div className="flex justify-end gap-3 pt-4 border-t mt-6">
                <button
                  onClick={() => {
                    setShowEditModal(false);
                    setEditingRehab(null);
                    setEditForm({
                      owner_name: '',
                      namuna_b_remarks: ''
                    });
                  }}
                  className="px-6 py-2.5 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  रद्द करा
                </button>
                <button
                  onClick={handleUpdateRemarks}
                  disabled={loading}
                  className="px-6 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 transition-colors flex items-center"
                >
                  {loading ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      जतन करत आहे...
                    </>
                  ) : (
                    'जतन करा'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Send to DRO Modal */}
      {showSendToDROModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <h2 className="text-xl font-bold mb-4">Send to DRO</h2>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Select DRO Officer *
                  </label>
                  <select
                    value={selectedUserDRO}
                    onChange={(e) => setSelectedUserDRO(e.target.value)}
                    disabled={loadingUsersDRO}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">
                      {loadingUsersDRO ? 'Loading Users...' : 'Select User'}
                    </option>
                    {usersDRO.map((user) => (
                      <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                        {user.full_name || user.user_name} ({user.usr_role || user.user_role})
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Remarks
                  </label>
                  <textarea
                    value={remarksDRO}
                    onChange={(e) => setRemarksDRO(e.target.value)}
                    rows={3}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter remarks..."
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Upload Document *
                  </label>
                  <input
                    type="file"
                    onChange={(e) => setSelectedDocumentDRO(e.target.files[0])}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                  {selectedDocumentDRO && (
                    <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                      <p className="text-sm text-green-700 font-medium">
                        Selected: {selectedDocumentDRO.name}
                      </p>
                      <span className="text-xs text-green-600">
                        {(selectedDocumentDRO.size / 1024 / 1024).toFixed(2)} MB
                      </span>
                    </div>
                  )}
                </div>
              </div>

              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button
                  onClick={() => {
                    setShowSendToDROModal(false);
                    setSelectedDocumentDRO(null);
                  }}
                  className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                  disabled={sendingToDRO}
                >
                  Cancel
                </button>
                <button
                  onClick={handleSendToDRO}
                  disabled={sendingToDRO || !selectedUserDRO || !selectedDocumentDRO}
                  className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                >
                  {sendingToDRO ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      Sending...
                    </>
                  ) : (
                    <>
                      <Send className="mr-2 h-4 w-4" />
                      Send
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showSignaturePad && pdfForSigning && (
  <SignaturePad
    pdfFile={pdfForSigning}
    onSign={(signaturesArray) => {
      setShowSignaturePad(false);

      // ✅ ONLY sign here
      signDocument(pdfForSigning, signaturesArray);

      setPdfForSigning(null);
    }}
    onCancel={() => {
      setShowSignaturePad(false);
      setPdfForSigning(null);
    }}
  />
)}

{isViewerOpen && viewerFile && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
    <div className="bg-white rounded-lg w-[80%] max-w-6xl h-[80%] relative">

      <div className="flex justify-between items-center px-4 py-2 border-b">
        <h3 className="text-lg font-semibold">Signed Document</h3>
        <button
          onClick={() => setIsViewerOpen(false)}
          className="text-xl font-bold"
        >
          ✕
        </button>
      </div>

      <iframe
        src={viewerFile}
        title="Signed PDF Viewer"
        className="w-full h-full"
      />
    </div>
  </div>
)}

{(uploadStatus === "signing" || uploadStatus === "uploading") && (
  <SignatureLoader
    text={
      uploadStatus === "signing"
        ? "Applying digital signature…"
        : "Uploading signed document…"
    }
  />
)}

    </div>
  );
};

export default Namuna_B;